import React from 'react';
import PropTypes from 'prop-types';
import ContactFilter from "./ContactFilter";
import ChatItem from "./ChatItem";
import {FormattedMessage} from "react-intl";
import {Row, Col, Button, FormGroup, InputGroup, Input, InputGroupAddon, InputGroupText} from 'reactstrap';
import Loading from "components/Loading";
import Textarea from "react-textarea-autosize";

class Conversation extends React.Component {
    static propTypes = {
        contactFilter: PropTypes.string,
        onContactFilterChange: PropTypes.func.isRequired,
        contacts: PropTypes.array.isRequired,
        onSaveNote: PropTypes.func.isRequired,
        canSendSms: PropTypes.bool,
        onSendSms: PropTypes.func.isRequired,
        onRead: PropTypes.func.isRequired,
        onLoadMoreContacts: PropTypes.func.isRequired,
        hasMore: PropTypes.bool,
        changeView: PropTypes.func.isRequired,
        view: PropTypes.oneOf(['controls', 'conversation', 'notes', 'advert']),
        id: PropTypes.number,
    };

    constructor(props) {
        super(props);

        this.list = null;

        this.onScroll = this.onScroll.bind(this);
        this.onSmsInputChange = this.onSmsInputChange.bind(this);
        this.onSmsInputKeyUp = this.onSmsInputKeyUp.bind(this);
    }

    componentWillMount() {
        this.setState({
            sms: '',
            onBottom: true,
        });
    }

    componentDidMount() {
        if (this.list) {
            this.list.onscroll = this.onScroll;
            if (this.list.hasChildNodes()) {
                this.list.lastChild.scrollIntoView();
            }
        }
        this.props.onRead();
    }

    componentDidUpdate(oldProps) {
        if (this.props.contacts.length !== oldProps.contacts.length || this.props.id !== oldProps.id) {
            this.props.onRead();

            if (this.state.onBottom && this.list.hasChildNodes()) {
                this.list.lastChild.scrollIntoView();
            }
        }
    }

    onScroll() {
        if (!this.list) {
            return;
        }
        const onBottom = (this.list.scrollHeight - this.list.offsetHeight) === this.list.scrollTop;
        if (onBottom !== this.state.onBottom) {
            this.setState({onBottom});
        }
    }

    onSmsInputChange(event) {
        const value = event.target.value;
        this.setState({
            sms: value
        });
    }

    onSmsInputKeyUp(event) {
        const key = event.key;
        if (key === "Enter" && this.state.sms.trim().length > 0) {
            this.props.onSendSms(this.state.sms);
            this.setState({
                sms: ''
            });
        }
    }

    loadMore() {
        this.setState({
            loadingMore: true,
        });
        this.props.onLoadMoreContacts().then(() => {
            this.setState({
                loadingMore: false
            });
        });
    }

    render() {
        const {
            contactFilter,
            hasMore,
            onContactFilterChange,
            contacts,
            onSaveNote,
            canSendSms,
            changeView,
            className,
            onLoadMoreContacts,
            onRead,
            onSendSms,
            view,
            ...props
        } = this.props;

        const {sms} = this.state;
        let classes = "col-md-8 ";
        if (className) {
            classes += className;
        }

        return (
            <div className={classes} {...props}>
                <div className={"links" + (view ? '' : ' d-none')}>
                    <ul>
                        <li><a onClick={() => changeView('advert')} tabIndex={5}><FormattedMessage
                            id="conversation.links.advert" defaultMessage="Advertisement"/></a></li>
                        <li><a onClick={() => changeView('notes')} tabIndex={6}><FormattedMessage
                            id="conversation.links.notes" defaultMessage="Notes"/></a></li>
                    </ul>
                </div>

                <ContactFilter onContactFilterChange={onContactFilterChange} contactFilter={contactFilter}/>

                <div ref={el => this.list = el} className={"chat__list" + (canSendSms ? '' : ' chat__list--no-sms')}>
                    {hasMore &&
                    <Row>
                        <Col md={{size: 6, offset: 3}}>
                            <Button block color="secondary" onClick={::this.loadMore} disabled={this.state.loadingMore}>
                                {this.state.loadingMore &&
                                <Loading inline small/>
                                }
                                <FormattedMessage id="load_more" defaultMessage="Load more"/>
                            </Button>
                        </Col>
                    </Row>
                    }

                    {contacts.map(contact => (
                        <ChatItem onSaveNote={(note) => onSaveNote(contact.id, note)} contact={contact}
                                  key={"contact-" + contact.id}/>
                    ))}
                </div>

                {canSendSms &&
                <div className="chat__sms">
                    {/*
                    <a href="#" className="chat__alert"/>
                    <a href="#" className="chat__photo"/>
                    */}
                    <div className="chat__input">
                        <FormGroup>
                            <InputGroup>
                                <FormattedMessage id="conversation.write_sms" defaultMessage="Write SMS"
                                                  children={message => (
                                                      <Textarea value={sms} placeholder={message}
                                                                onChange={this.onSmsInputChange}
                                                                onKeyUp={this.onSmsInputKeyUp}
                                                                className="form-control"/>
                                                  )}/>
                                <InputGroupAddon addonType="append">
                                    <InputGroupText>
                                        <FormattedMessage id="conversation.sms_length"
                                                          defaultMessage="Character count: {count}"
                                                          values={{count: sms.length}}/>
                                    </InputGroupText>
                                </InputGroupAddon>
                            </InputGroup>
                        </FormGroup>
                    </div>
                </div>
                }
            </div>
        )
    }
}

export default Conversation;


// WEBPACK FOOTER //
// ./src/containers/Conversations/Content/Conversation/Conversation.jsx